import type { SxProps, Theme } from '@mui/material';

export const styles = {
    page: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        gap: 2,
    } as SxProps<Theme>,
    topBar: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    } as SxProps<Theme>,
    backBtn: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.blue.main,
        color: theme.palette.white,
        textTransform: 'none',
        fontWeight: 600,
        '& .MuiButton-startIcon .MuiSvgIcon-root': { color: 'white' },
        '&:hover': {
            backgroundColor: theme.palette.blue[800],
            color: theme.palette.white,
        },
    }),
    body: {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: 2, md: 3 },
        flex: 1,
        minHeight: 0,
        overflow: { xs: 'auto', md: 'visible' },
    } as SxProps<Theme>,
    formColumn: {
        flex: { md: 7 },
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: { xs: 'visible', md: 'auto' },
    } as SxProps<Theme>,
    cartColumn: {
        flex: { md: 3 },
        minWidth: { md: 320 },
        display: 'flex',
        flexDirection: 'column',
        overflow: { xs: 'visible', md: 'auto' },
    } as SxProps<Theme>,
};
